import { render, staticRenderFns } from "./OfferDom.vue?vue&type=template&id=51c46ac6&scoped=true&"
import script from "./OfferDom.vue?vue&type=script&lang=js&"
export * from "./OfferDom.vue?vue&type=script&lang=js&"
import style0 from "./OfferDom.vue?vue&type=style&index=0&id=51c46ac6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c46ac6",
  null
  
)

export default component.exports